export default __webpack_public_path__ + "i18n/tr.fffd84d2590413dcf171e6040a68339c.json";